import { useSelector } from 'react-redux'

const useBillingActive = () => {
  const { isBillingActive } = useSelector(({ billing }) => billing)

  return isBillingActive
}

export default useBillingActive
